import { CommonConfig } from '../configs/config.common';
import * as moment from 'moment';

export function formatDateTime(dateTime: string): string {
    const format = new CommonConfig().dateTimeFormat;
    return moment(dateTime).format(format);
}

export function formatTime(dateTime: string): string {
    const format = new CommonConfig().timeFormat;
    return moment(dateTime).format(format);
}

export function formatDate(dateTime: string): string {
    const format = new CommonConfig().dateFormat;
    return moment(dateTime).format(format);
}
